<template>
  <div>
    <div class="spinner">
      <div :style="spinnerSize" class="bounce1"></div>
      <div :style="spinnerSize" class="bounce2"></div>
      <div :style="spinnerSize" class="bounce3"></div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      size: {
        type: String,
        default: '18px'
      }
    },

    data () {
      return {
        spinnerSize: {
          width: this.size,
          height: this.size
        }
      }
    }
  }
</script>

<style>
.spinner {
  text-align: center;
}

.spinner > div {
  width: 18px;
  height: 18px;
  background-color: rgba(255,255,255, 0.85);

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0) }
  40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Spinner.vue